export default __webpack_public_path__ + "static/media/personalPolicy.393edf08.svg";